import React from "react";

function NoDataAvailable() {
  return (
    <div className="text-uppercase bold text-center">
      <h4>No data to display</h4>
    </div>
  );
}

export default NoDataAvailable;



// WEBPACK FOOTER //
// ./src/components/common/errorBoundary/noDataAvailable/NoDataAvailable.jsx